import React from "react";
import CharacterKnowledgeContent from "../knowledge/CharacterKnowledgeContent";

interface KnowledgePanelProps {
  campaignId?: number;
  /** Campaign creator username — used to suppress panel for DMs. */
  campaignCreatedBy?: string;
  className?: string;
}

/**
 * Floating Knowledge panel — Surface 2 of the Character Knowledge View feature.
 *
 * Rendered inside a FloatingPanel shell in SessionLayout. Shows the compact
 * variant of CharacterKnowledgeContent (stacked tree + inline detail).
 */
export const KnowledgePanel: React.FC<KnowledgePanelProps> = ({
  campaignId,
  campaignCreatedBy,
  className,
}) => {
  if (!campaignId) {
    return (
      <div className={`text-zinc-400 text-sm p-4 ${className ?? ""}`}>
        <p>No campaign associated with this session.</p>
      </div>
    );
  }

  return (
    <div className={`h-full flex flex-col overflow-hidden ${className ?? ""}`}>
      <CharacterKnowledgeContent
        campaignId={campaignId}
        mode="compact"
        campaignCreatedBy={campaignCreatedBy}
      />
    </div>
  );
};

export default KnowledgePanel;
